import React from 'react';
import { Footprints, TrendingUp } from 'lucide-react';
import { CAMINO_PAGES } from '../config/caminoPages';

export const CaminoStats = ({ stats }) => {
  const max = Math.max(1, ...stats.map((s) => s.total));
  const total = stats.reduce((a, s) => a + s.total, 0);
  const best = stats.reduce((a, s) => (s.total > (a?.total || 0) ? s : a), null);
  return (
    <div data-testid="camino-stats">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-bold text-[#4A4A4A]">Descargas de las infografías del Camino</h3>
          <p className="text-sm text-gray-500">Cada vez que un peregrino pulsa "Descargar PDF" tras escanear una pegatina</p>
        </div>
        <div className="text-right">
          <p className="text-3xl font-extrabold text-[#4A4A4A]" data-testid="camino-total-downloads">{total}</p>
          <p className="text-xs text-gray-500">descargas en total</p>
        </div>
      </div>
      {best && best.total > 0 && (
        <div className="mb-4 px-4 py-3 rounded-xl bg-[#EEF7EA] text-sm text-[#4A4A4A] flex items-center gap-2" data-testid="camino-best">
          <TrendingUp className="w-4 h-4 text-[#6BA368]" />
          La que mejor funciona: <strong>Infografía {CAMINO_PAGES.find((p) => p.slug === best.slug)?.number}</strong> ({best.total} descargas)
        </div>
      )}
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        {stats.map((s, i) => {
          const cfg = CAMINO_PAGES.find((p) => p.slug === s.slug);
          return (
            <div key={s.slug} data-testid={`camino-stat-${s.slug}`} className={`p-5 ${i !== stats.length - 1 ? 'border-b border-gray-100' : ''}`}>
              <div className="flex items-center justify-between gap-4 mb-2">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: `${cfg?.accent || '#7DBDD9'}33` }}>
                    <Footprints className="w-4 h-4" style={{ color: cfg?.accent || '#7DBDD9' }} />
                  </div>
                  <div className="min-w-0">
                    <p className="font-semibold text-[#4A4A4A] truncate">Infografía {cfg?.number} · {cfg?.subline}</p>
                    <p className="text-xs text-gray-500">
                      Últimos 7 días: <strong>{s.last_7_days}</strong> · Últimos 30 días: <strong>{s.last_30_days}</strong>
                      {s.last_download ? ` · Última: ${new Date(s.last_download).toLocaleDateString('es-ES')}` : ''}
                    </p>
                  </div>
                </div>
                <p className="text-2xl font-extrabold text-[#4A4A4A] flex-shrink-0">{s.total}</p>
              </div>
              <div className="h-2 rounded-full bg-gray-100 overflow-hidden">
                <div className="h-full rounded-full transition-all" style={{ width: `${(s.total / max) * 100}%`, background: cfg?.accent || '#7DBDD9' }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
